import { $fetch } from './request';

// 获取验证码
export const getCode = (data) => {
  return $fetch({
    url: '/mailcode',
    data
  });
};

// 登陆
export const login = (data) => {
  return $fetch({
    url: '/users',
    data
  });
}

export const getUserInfo = (url, headers) => {
  return $fetch({
    method: 'get',
    url,
    headers
  });
}
